export default __webpack_public_path__ + "static/media/ContractNote.898ec4da.pdf";